import './header';
import './search';
import {initCustomSelect} from './customSelect'

initCustomSelect()
